import * as localStorageService from './localStorage';

const user = localStorageService.getUser();
const uid = user && user.uid ? user.uid : '';

const gtag = window.gtag ? window.gtag : () => {};

const gtagEvent = (event = 'EVENT', payload = { uid }) => {
  gtag('event', event, { ...payload, uid });
};

export default gtagEvent;
